import React, { Children, useEffect, useState } from "react";
import CustomText from "pages/_components/CustomText/CustomText";
import { actions as depositsActions } from "reducers/deposits";
import { useDispatch } from "react-redux";
import { customTabsPropType, defaultCustomTabsPropType } from "./customTabsPropType";
import { resizableRoute as resizableComponent } from "../Resizable";
import useTabs from "./useTabs";

const CustomTabs = ({
    isPersistent,
    tabsData,
    className,
    children,
    defaultTab,
    isDesktop,
    tab,
    classNameTwo,
    classNameRow = "",
}) => {
    const [arrayChildren, setArrayChildren] = useState(Children.toArray(children));
    const [arrayHeader, setArrayHeader] = useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        if (arrayChildren[0]?.type?.name === "CustomTabsHeader") {
            setArrayHeader(arrayChildren[0].props.children);
            setArrayChildren(arrayChildren.splice(1, arrayChildren.length - 1));
        }
    }, [arrayChildren, setArrayChildren, setArrayHeader]);

    const { currentTabIndex, setCurrentTabIndex } = useTabs(isPersistent, defaultTab, isDesktop, tab);

    const customClass = `custom-tabs ${className}`;

    const handleOnClick = (index) => {
        if (index === 0) {
            dispatch(depositsActions.setDepositTab(true));
        } else {
            dispatch(depositsActions.setDepositTab(false));
        }
        setCurrentTabIndex(index);
    };

    return (
        <div className={`container--layout flex-grow ${customClass}`}>
            <div className={`custom-tabs-row ${classNameRow}`}>
                {tabsData.map((tabData, index) => (
                    <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${tabData.text}-${index}`}
                        onClick={() => handleOnClick(index)}
                        className={`tab custom-tab${index === currentTabIndex ? " active" : ""} ${classNameTwo}`}>
                        <CustomText {...tabData} />
                    </div>
                ))}
                {arrayHeader.map((tabData, index) => (
                    <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${tabData.props.text}-${index}`}
                        onClick={() => handleOnClick(index)}
                        className={`tab custom-tab${index === currentTabIndex ? " active" : ""}`}>
                        {tabData}
                    </div>
                ))}
            </div>
            <div className="custom-tabs-body">
                {tabsData[currentTabIndex]?.content
                    ? tabsData[currentTabIndex].content
                    : arrayChildren[currentTabIndex]}
            </div>
        </div>
    );
};

CustomTabs.propTypes = customTabsPropType;
CustomTabs.defaultProps = defaultCustomTabsPropType;

const CustomTabsHeader = ({ children }) => children;
CustomTabs.Header = CustomTabsHeader;

export default resizableComponent(CustomTabs);
